import { CreateConsentLogPayload } from "@app/types";
import HttpService from "@core/services/http/http.service";

class _ConsentLogService {
  public createConsentLog(body: CreateConsentLogPayload) {
    return HttpService.post<any>("/consent-logs", {
      body: { ...body },
    });
  }
}

const ConsentLogService = new _ConsentLogService();

export default ConsentLogService;
